module.exports = __webpack_public_path__ + "img/mobile-android-logo.6b10fba0.svg";